import { appData } from '@/mocks/homeData';

export default function AppSection() {
  return (
    <section id="app" className="py-16 md:py-20 bg-background-100">
      <div className="max-w-[960px] mx-auto px-4 md:px-6">
        <div className="rounded-2xl bg-background-50 border border-background-200 p-6 md:p-10 flex flex-col md:flex-row items-center gap-8">
          <div className="flex-1 text-center md:text-left">
            <span className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-accent-100 text-accent-700 text-xs font-medium mb-3">
              <i className="ri-smartphone-line"></i>
              移动端专属体验
            </span>
            <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-950 mb-3">
              {appData.title}
            </h2>
            <p className="text-sm text-foreground-500 leading-relaxed mb-5">
              {appData.description}
            </p>
            <div className="flex flex-wrap items-center justify-center md:justify-start gap-3">
              {appData.features.map((feat) => (
                <span
                  key={feat}
                  className="flex items-center gap-1 px-3 py-1.5 rounded-lg bg-background-100 text-xs text-foreground-600 whitespace-nowrap"
                >
                  <i className="ri-check-line text-accent-500 text-sm"></i>
                  {feat}
                </span>
              ))}
            </div>
          </div>
          <div className="flex-shrink-0 flex items-center justify-center">
            <div className="w-36 h-36 rounded-2xl bg-background-200 flex items-center justify-center">
              <i className="ri-smartphone-line text-5xl text-primary-400"></i>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}